<p-card styleClass="stats">
  <ng-template pTemplate="header">
    <div class="p-card-title">
      {{ stats()?.content?.title }}
    </div>
    <button
      pButton
      [icon]="stats()?.content?.button?.icon || ''"
      class="button"
      [class]="stats()?.content?.button?.color"
      [title]="'Details'"
      (click)="routesService.list(stats()?.content?.button?.resource ?? '')"
    ></button>
  </ng-template>
  <div class="content">
    <div>
      <div class="value">{{ stats()?.content?.value}}</div>
    </div>
  </div>
    @if (stats()?.value) {
      <span class="value">{{ stats()?.value }} </span>
    }
    @if (stats()?.comment) {
      <span class="comment">{{ stats()?.comment }}</span>
    }
</p-card>
